module.exports = __webpack_public_path__ + "static/media/Pin_Job_Engine.8ec0c89d.svg";